import { Skeleton } from '@linka/ui/skeleton';
import React, { Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';
import DefaultLayout from '@/ui/components/default-layout';
import { Home } from '@/ui/pages/home';

const NotFound = React.lazy(() => import('@/ui/pages/not-found').then((m) => ({ default: m.NotFound })));
const LoginPage = React.lazy(() => import('@/ui/pages/auth/login').then((m) => ({ default: m.LoginFlow })));
const RegisterPage = React.lazy(() => import('@/ui/pages/auth/register').then((m) => ({ default: m.RegisterPage })));
const ForgotPasswordPage = React.lazy(() =>
  import('@/ui/pages/auth/forgot-password').then((m) => ({
    default: m.ForgotPasswordPage,
  })),
);
const ActivationCodePage = React.lazy(() =>
  import('@/ui/pages/auth/activation-code').then((m) => ({
    default: m.ActivationCodePage,
  })),
);
const ResetPasswordPage = React.lazy(() =>
  import('@/ui/pages/auth/reset-password').then((m) => ({
    default: m.ResetPasswordPage,
  })),
);
const ContactPage = React.lazy(() =>
  import('@/ui/pages/home/pages/contact').then((m) => ({
    default: m.ContactPage,
  })),
);

export default [
  {
    path: '/auth',
    element: <DefaultLayout />,
    children: [
      { index: true, element: <Navigate to='login' replace /> },
      {
        path: 'login',
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <LoginPage />
          </Suspense>
        ),
      },
      {
        path: 'register',
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <RegisterPage />
          </Suspense>
        ),
      },
      {
        path: 'activation-code',
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <ActivationCodePage />
          </Suspense>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <ForgotPasswordPage />
          </Suspense>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <ResetPasswordPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/',
    element: <DefaultLayout fixedHeader fullWidth />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: 'contact',
        element: (
          <Suspense fallback={<Skeleton className='h-screen' />}>
            <ContactPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<Skeleton className='h-screen' />}>
        <NotFound />
      </Suspense>
    ),
  },
] as RouteObject[];
